import { Routes } from '@angular/router';
import { payrollManagerRoleGuard } from '@zvoove-market/shared';

export const payrollManagerRoutes: Routes = [
  {
    path: 'payroll-manager',
    canActivate: [payrollManagerRoleGuard()],
    loadComponent: () => import('./shell/payroll-manager-shell.page').then((c) => c.PayrollManagerShellPage),
    data: {
      breadcrumb: () => $localize`:@@shell.payrollManager:Payrollverwalter`,
    },
    children: [
      {
        path: '',
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./payroll-manager-ticket/search/payroll-manager-ticket-search.page').then((c) => c.PayrollManagerTicketSearchPage),
          },
          {
            path: ':accountId',
            children: [
              {
                path: '',
                loadComponent: () =>
                  import('./payroll-manager-ticket/list/payroll-manager-ticket-list.page').then((c) => c.PayrollManagerTicketListPage),
              },
              {
                path: 'add',
                loadComponent: () =>
                  import('./payroll-manager-ticket/detail/payroll-manager-ticket-detail.page').then(
                    (c) => c.PayrollManagerTicketDetailPage
                  ),
                data: {
                  breadcrumb: () => $localize`:@@case.mailTicket:Ticket mailen`,
                },
              },
              {
                path: ':caseId',
                loadComponent: () =>
                  import('./payroll-manager-ticket/detail/payroll-manager-ticket-detail.page').then(
                    (c) => c.PayrollManagerTicketDetailPage
                  ),
                data: {
                  breadcrumb: () => $localize`:@@general.editEntry:Eintrag bearbeiten`,
                },
              },
            ],
          },
        ],
      },
    ],
  },
];
